export default {
  container: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center'
  }
}
